/* TLC Find My Size, "Slide and see" style.
   Restyles every Find My Size quiz (tlc-XX-overlay) on product pages.
   It does not replace the quizzes: every slider, wheel and toggle taps the
   quiz's own answer buttons, and the size comes from the quiz's own logic. */
(function () {
  var SHORT = {
    legs: { 'short': 'Shorter', average: 'Average', 'long': 'Longer' },
    pref: { flowy: 'Flowy', relaxed: 'Relaxed', controlled: 'Close', fitted: 'Close', less: 'Neat' },
    bust: { small: 'A to C', full: 'D to DD', vfull: 'E and up' },
    thigh: { slim: 'Slim to average', fuller: 'Fuller' },
    lengthpref: { important: 'Length matters', notmind: "Don't mind" }
  };
  var PRETTY = { XS: 'XS', SM: 'S/M', ML: 'M/L', LXL: 'L/XL', XL: 'XL', XXL: 'XXL', '3XL': '3XL' };

  function norm(s) { return String(s || '').replace(/\(.*?\)/g, '').replace(/[^a-z0-9]/gi, '').toLowerCase(); }
  function pretty(s) { var k = String(s || '').trim().toUpperCase(); return PRETTY[k] || s; }
  function txt(el, sel) { var e = el.querySelector(sel); return e ? e.textContent.trim() : ''; }
  function clean(s) { return String(s || '').replace(/\s+[–—-]\s+/g, ' to ').trim(); }
  function feet(cm) { var i = Math.round(cm / 2.54); return Math.floor(i / 12) + "'" + (i % 12) + '"'; }

  function shortLabel(step, val, main) {
    if (SHORT[step] && SHORT[step][val]) return SHORT[step][val];
    var m = main.split(' / ')[0];
    var w = m.split(' ');
    return w.length > 3 ? w.slice(0, 3).join(' ') : m;
  }

  function parseHeights(opts) {
    var ranges = [];
    for (var i = 0; i < opts.length; i++) {
      var t = (opts[i].querySelector('[class$="-opt-main"]') || opts[i]).textContent;
      var n = (t.match(/\d{3}/g) || []).map(Number);
      if (!n.length || !/cm/i.test(t)) return null;
      if (/under|below/i.test(t)) ranges.push([0, n[0] - 1]);
      else if (/over|above|\+/i.test(t)) ranges.push([n[0], 999]);
      else if (n.length >= 2) ranges.push([n[0], n[1]]);
      else return null;
    }
    return ranges;
  }

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }

  var productPromise = null;
  function getProduct() {
    if (!productPromise) {
      var path = location.pathname.replace(/\/$/, '');
      productPromise = fetch(path + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }
    return productPromise;
  }

  function findVariant(product, sizeLabel) {
    var idx = -1;
    (product.options || []).forEach(function (o, i) { var n = (o.name || o).toString().toLowerCase(); if (n.indexOf('size') > -1) idx = i; });
    if (idx < 0) idx = 0;
    var want = norm(sizeLabel);
    var currentId = (document.querySelector('form[action*="/cart/add"] [name="id"]') || {}).value;
    var current = null;
    product.variants.forEach(function (v) { if (String(v.id) === String(currentId)) current = v; });
    var matches = product.variants.filter(function (v) { return norm(v.options[idx]) === want; });
    if (current) {
      var same = matches.filter(function (v) { return v.options.every(function (o, i) { return i === idx || o === current.options[i]; }); });
      if (same.length) matches = same;
    }
    return matches[0] || null;
  }

  function init(ov) {
    if (ov.getAttribute('data-fms')) return;
    var opts = ov.querySelectorAll('[data-step]');
    if (!opts.length) return;
    var k = ov.id.replace(/^tlc-/, '').replace(/-overlay$/, '');
    var P = 'tlc-' + k + '-';
    var sheet = document.getElementById(P + 'sheet');
    var findBtn = document.getElementById(P + 'find-btn');
    var rSize = document.getElementById(P + 'r-size');
    if (!sheet || !findBtn || !rSize) return;
    ov.setAttribute('data-fms', '1');
    ov.classList.add('fms');

    /* Entry point on the page: "The fit ... Find my size >" */
    document.querySelectorAll('.' + P + 'trigger').forEach(function (t) {
      t.classList.add('fms-trigger');
      t.innerHTML = '<span class="fms-trigger__lab">The fit</span><span class="fms-trigger__link">Find my size <span aria-hidden="true">&rsaquo;</span></span>';
    });

    /* Header label */
    var h2 = ov.querySelector('.' + P + 'modal-header h2');
    var pname = (document.querySelector('.product-title, h1') || {}).textContent || '';
    pname = pname.split('|')[0].trim();
    if (h2) h2.textContent = 'Find my size' + (pname ? ' · ' + pname : '');

    /* Group the quiz's own answer buttons by question */
    var steps = [], byStep = {};
    opts.forEach(function (o) {
      var s = o.getAttribute('data-step');
      if (!byStep[s]) { byStep[s] = { step: s, opts: [] }; steps.push(byStep[s]); }
      byStep[s].opts.push(o);
    });

    var ctrl = el('div', 'fms-ctrl');
    var firstCont = steps[0].opts[0].parentElement;
    var firstLabel = firstCont.previousElementSibling;
    while (firstLabel && !/-qlabel/.test(firstLabel.className)) firstLabel = firstLabel.previousElementSibling;
    (firstLabel || firstCont).parentNode.insertBefore(ctrl, firstLabel || firstCont);

    var answered = {};
    var bar, barSize, barNote, barBtn, current = null;

    function pick(step, o) {
      answered[step] = true;
      o.click();
      update();
    }

    steps.forEach(function (s) {
      var cont = s.opts[0].parentElement;
      var q = cont.previousElementSibling;
      while (q && !/-qlabel/.test(q.className)) q = q.previousElementSibling;
      var question = q ? q.textContent.replace(/^\s*\d+\.\s*/, '').trim() : s.step;
      cont.classList.add('fms-hide');
      if (q) q.classList.add('fms-hide');

      var blk = el('div', 'fms-blk');
      blk.appendChild(el('div', 'fms-q', question));
      var mains = s.opts.map(function (o) { return (o.querySelector('[class$="-opt-main"]') || o).textContent.trim(); });
      var subs = s.opts.map(function (o) { var e = o.querySelector('[class$="-opt-sub"]'); return e ? e.textContent.trim() : ''; });
      var ranges = s.step === 'height' ? parseHeights(s.opts) : null;
      var numeric = mains.every(function (m) { return /^\d+$/.test(m); });

      if (ranges) {
        var lo = 145, hi = 190;
        var val = el('div', 'fms-val', '<span>Slide to your height</span>');
        var input = el('input', 'fms-range');
        input.type = 'range'; input.min = lo; input.max = hi; input.step = 1; input.value = 165;
        input.setAttribute('aria-label', question);
        var ends = el('div', 'fms-ends', '<span>' + lo + 'cm</span><span>' + hi + 'cm</span>');
        var last = -1;
        input.addEventListener('input', function () {
          var cm = +input.value;
          blk.classList.add('is-set');
          val.innerHTML = cm + 'cm<small>' + feet(cm) + '</small>';
          for (var i = 0; i < ranges.length; i++) {
            if (cm >= ranges[i][0] && cm <= ranges[i][1]) {
              if (i !== last) { last = i; pick(s.step, s.opts[i]); }
              break;
            }
          }
        });
        blk.appendChild(val); blk.appendChild(input); blk.appendChild(ends);
      } else if (numeric) {
        var wheel = el('div', 'fms-wheel');
        s.opts.forEach(function (o, i) {
          var b = el('button', 'fms-num', mains[i]); b.type = 'button';
          b.addEventListener('click', function () {
            wheel.querySelectorAll('.fms-num').forEach(function (x) { x.classList.remove('is-on'); });
            b.classList.add('is-on');
            var left = b.offsetLeft - (wheel.clientWidth - b.offsetWidth) / 2;
            if (wheel.scrollTo) wheel.scrollTo({ left: left, behavior: 'smooth' });
            pick(s.step, o);
          });
          wheel.appendChild(b);
        });
        blk.appendChild(wheel);
        setTimeout(function () {
          var mid = wheel.children[Math.min(4, wheel.children.length - 1)];
          if (mid) wheel.scrollLeft = mid.offsetLeft - (wheel.clientWidth - mid.offsetWidth) / 2;
        }, 50);
      } else {
        var seg = el('div', 'fms-seg' + (s.opts.length > 3 ? ' fms-seg--grid' : ''));
        var help = el('div', 'fms-help', '');
        s.opts.forEach(function (o, i) {
          var b = el('button', 'fms-segbtn', shortLabel(s.step, o.getAttribute('data-value'), mains[i])); b.type = 'button';
          b.addEventListener('click', function () {
            seg.querySelectorAll('.fms-segbtn').forEach(function (x) { x.classList.remove('is-on'); });
            b.classList.add('is-on');
            help.textContent = clean(subs[i] || mains[i]);
            pick(s.step, o);
          });
          seg.appendChild(b);
        });
        blk.appendChild(seg); blk.appendChild(help);
      }
      ctrl.appendChild(blk);
    });

    /* Live size bar */
    bar = el('div', 'fms-live');
    var left = el('div', 'fms-live__l');
    left.appendChild(el('div', 'fms-live__lab', 'Your size'));
    barSize = el('div', 'fms-live__size', '');
    barNote = el('div', 'fms-live__note', '');
    left.appendChild(barSize); left.appendChild(barNote);
    barBtn = el('button', 'fms-live__btn', 'Add to cart'); barBtn.type = 'button'; barBtn.disabled = true;
    bar.appendChild(left); bar.appendChild(barBtn);
    sheet.appendChild(bar);

    function update() {
      var left = steps.filter(function (s) { return !answered[s.step]; }).length;
      if (left > 0 || findBtn.disabled) {
        barSize.textContent = '';
        barNote.textContent = left === 1 ? '1 more to go' : left + ' more to go';
        bar.classList.remove('is-ready');
        barBtn.disabled = true; barBtn.textContent = 'Add to cart';
        current = null;
        return;
      }
      var siv = Element.prototype.scrollIntoView;
      Element.prototype.scrollIntoView = function () {};
      try { findBtn.click(); } finally { Element.prototype.scrollIntoView = siv; }
      var size = rSize.textContent.trim();
      barSize.textContent = pretty(size);
      barNote.textContent = '';
      bar.classList.add('is-ready');
      current = null;
      barBtn.disabled = true; barBtn.textContent = 'Add ' + pretty(size);
      getProduct().then(function (p) {
        var v = findVariant(p, size);
        current = v;
        if (!v) { barBtn.textContent = 'Choose on page'; barBtn.disabled = false; return; }
        if (!v.available) { barBtn.textContent = pretty(size) + ' sold out'; barBtn.disabled = true; return; }
        barBtn.disabled = false;
      }).catch(function () { barBtn.disabled = false; barBtn.textContent = 'Choose on page'; });
    }

    function closeQuiz() {
      var c = ov.querySelector('.' + P + 'modal-close');
      if (c) c.click();
    }

    barBtn.addEventListener('click', function () {
      if (!current) { closeQuiz(); return; }
      barBtn.disabled = true; barBtn.textContent = 'Adding';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: current.id, quantity: 1 })
      }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); }).then(function () {
        barBtn.textContent = 'Added';
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('.cart-link__count,[data-cart-count]').forEach(function (b) { b.textContent = cart.item_count; });
        });
        setTimeout(function () {
          closeQuiz();
          if (typeof window.monster_refresh === 'function') window.monster_refresh();
          barBtn.disabled = false; barBtn.textContent = 'Add ' + barSize.textContent;
        }, 600);
      }).catch(function () { barBtn.disabled = false; barBtn.textContent = 'Try again'; });
    });

    update();
  }

  function run() { document.querySelectorAll('[id^="tlc-"][id$="-overlay"]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
